var tonemappingNonePS = `
vec3 toneMap(vec3 color) {
	return color;
}
`;

export { tonemappingNonePS as default };
